<section>
    <h3>
        {{ title }}
    </h3>
    <ul>
        <li *ngFor="let skill of skills"><app-skill-card [title]="skill.title" [skill]="skill.skill"></app-skill-card></li>
    </ul>
</section>
